import { render, staticRenderFns } from "./points-rule.vue?vue&type=template&id=720f1f6d&scoped=true"
import script from "./points-rule.vue?vue&type=script&lang=js"
export * from "./points-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f1f6d",
  null
  
)

export default component.exports